import lazyLoad from 'app/shared-components/util/lazyLoad';

const ConfirmSignupPage = lazyLoad(() => import('./ConfirmSignupPage'));
const AwaitConfirmPage = lazyLoad(() => import('./AwaitConfirmPage'));

import authRoles from '../../auth/authRoles';



const ConfirmSignupConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'await-confirm',
      element: <AwaitConfirmPage />,
    },
    {
      path: 'confirm',
      element: <ConfirmSignupPage />,
    },
  ],
};

export default ConfirmSignupConfig;
